import Text from '@zenbusiness/zui/Text';

import { HIGHLIGHT_TEXT_PREFIXES } from './constants';

export const highlightText = (ctaText, HighlightComponent) => {
  if (!ctaText) return '';

  const prefixes = HIGHLIGHT_TEXT_PREFIXES;

  for (const prefix of prefixes) {
    if (ctaText.toLowerCase().includes(prefix)) {
      const regex = new RegExp(prefix, 'i');
      const match = ctaText.match(regex);
      const parts = ctaText.split(regex);

      if (match && parts.length === 2) {
        return (
          <>
            <Text>{match[0]}&nbsp;</Text>
            <HighlightComponent>{parts[1]}</HighlightComponent>
          </>
        );
      }
    }
  }

  return ctaText;
};
